import * as React from "react"
import { storyblokEditable } from "gatsby-source-storyblok"
import { useState } from 'react';
import { init, Form } from '@feathery/react';
import { LangCode } from "../utils/lang"
import { useLocation } from '@reach/router';

const MultiStepForm = ({ blok }) => {
  // console.log(blok)

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const affiliate = queryParams.get('affiliate');
  var initialValues = {}
  initialValues['affiliate'] = affiliate ? affiliate : '';
  if(blok.initFieldId0) initialValues[blok.initFieldId0] = blok.initFieldValue0;
  if(blok.initFieldId1) initialValues[blok.initFieldId1] = blok.initFieldValue1;
  if(blok.tourCode) initialValues["tourCode"] = blok.tourCode;
  
  // console.log(initialValues)

  const langCode = LangCode()  
  
  // Initialize Feathery
  init('eeaa5623-09b6-42e5-944d-b11974b0154b');
  const [showPopup, setShowPopup] = useState(false);
  
  return (
    <section className="text-center max-w-[700px] mb-8 mx-auto p-4" {...storyblokEditable(blok)} id="multi-step-form">
      <h1 className="text-3xl font-bold">{blok.title}</h1>
      <p className="pt-10 max-w-[700px] mx-auto">{blok.description}</p>

      <div className="flex justify-center py-10">
        <button onClick={() => setShowPopup(true)} 
          className="text-lg text-blue-700 border-2 border-blue-700 rounded-lg py-2 px-8 flex items-center">
          {blok.ctaText}
          <img className="w-8 h-3 align-middle ml-4" src="/icons/arrow-right-blue.svg" alt="Arrow right"/>
        </button>
      </div>
      <Form
        className="bg-white"
        formName={blok.formName}
        initialValues={initialValues}
        language={langCode}
        popupOptions={{
          show: showPopup,
          onHide: () => setShowPopup(false),
        }}
      />

    </section>
  )
};

export default MultiStepForm;
